import { ol_format, ol_geom } from "@omnia/exports/openlayers"
import { isArray, isObject } from "../utils/utils"

type Position = [number, number]

const types = [
    "Point",
    "LineString",
    "Polygon",
    "MultiPoint",
    "MultiLineString",
    "MultiPolygon",
    "GeometryCollection"
]

type GeometryType = typeof types[number]

interface GeometryBase {
    type: GeometryType
}

interface Point extends GeometryBase {
    type: "Point"
    coordinates: Position
}

interface LineString extends GeometryBase {
    type: "LineString"
    coordinates: Position[]
}

interface Polygon extends GeometryBase {
    type: "Polygon"
    coordinates: Position[][]
}

interface MultiPoint extends GeometryBase {
    type: "MultiPoint"
    coordinates: Position[]
}

interface MultiLineString extends GeometryBase {
    type: "MultiLineString"
    coordinates: Position[][]
}

interface MultiPolygon extends GeometryBase {
    type: "MultiPolygon"
    coordinates: Position[][][]
}

interface GeometryCollection extends GeometryBase {
    type: "GeometryCollection"
    geometries: GeoJsonGeometry[]
}

export type GeoJsonGeometry =
    | Point
    | LineString
    | Polygon
    | MultiPoint
    | MultiLineString
    | MultiPolygon
    | GeometryCollection


const typesSet = new Set(types)

export function isGeojsonGeometry(obj: any): obj is GeoJsonGeometry {

    if (obj && isObject(obj)) {
        const type = obj["type"]
        if (!type) return false
        if (!typesSet.has(type)) return false
        return isArray(obj["coordinates"])
    }
}


const geoJsonFormat = new ol_format.GeoJSON()

export function convertGeoJsonToGeometry(geoJson: GeoJsonGeometry) {
    return geoJsonFormat.readGeometry(geoJson, { dataProjection: "EPSG:3857" })
}

export function convertGeometryToGeoJson(geom: ol_geom.Geometry) {
    return geoJsonFormat.writeGeometryObject(geom)
}
